// extracted by mini-css-extract-plugin
export default {"weeklySpace":"week_weeklySpace__0GHoH","weekLabels":"week_weekLabels__5P2QG","checked":"week_checked__6SLX7","unchecked":"week_unchecked__hyOoo"};